import "./upload.scss";

import {FunctionalComponent, h} from "preact";
import {useState} from "preact/hooks";
import {makePollAnswerMsg} from "./InputUIService";
import {useRef} from "preact/compat";
import {IcoCloudUpload} from "../components/icons";
import {log} from "../libs/QuerloLogger";
import {isImageMimeType, storeFile} from "./OpenAnswerHelper";

export const UploadAnswer: FunctionalComponent<{
    question: any; answerCallback: (answerRawObj: any) => void; backendBaseURL: string;
}> = ({question, answerCallback, backendBaseURL}) => {

    const allowMultipleUploads = false;
    const fileInputField = useRef<HTMLInputElement>(null);
    const [selectedFiles, setSelectedFiles] = useState<Record<string, File>>({});
    const [isUploading, setIsUploading] = useState(false);
    const [uploadPercent, setUploadPercent] = useState(0);


    function updateSelectedFiles(pickedFiles: FileList): void {
        setSelectedFiles((previousFilesState)  => {
            const newFilesState = {...previousFilesState};
            for (const file of pickedFiles as unknown as File[]) {
                if (!allowMultipleUploads) {
                    log.debug("Selected a file: ", file);
                    return {file};
                }
                newFilesState[file.name] = file;
            }
            return newFilesState;
        });
    }

    function handleChange(e: Event): void {
        e.preventDefault();
        const newFilesPickedFromGUI: FileList = (e.target as HTMLInputElement).files as FileList;

        if (newFilesPickedFromGUI === null) {
            log.error("Internal error, no files selected");
            return;
        }
        updateSelectedFiles(newFilesPickedFromGUI);
    }

    function removeSelectedFile(fName: string): void {
        setSelectedFiles((previousFilesState)  => {
            const newFilesState = {...previousFilesState};
            delete newFilesState[fName];
            return newFilesState;
        });
    }

    function handleSubmit(e: Event): void {
        e.preventDefault();
        if (Object.keys(selectedFiles).length === 0) {
            log.warn("No files selected");
            return;
        }
        if (isUploading) {
            log.warn("Upload is already in progress");
            return;
        }

        setIsUploading(true);

        const uploadData = new FormData();
        for (const fName in selectedFiles) {
            uploadData.append('file', selectedFiles[fName]);
            uploadData.append('type', 'chatUpload');
        }

        const uploadPromise: Promise<any> = new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.responseType = 'json';
            xhr.upload.onprogress = (event: ProgressEvent) => {
                setUploadPercent((event.loaded / event.total) * 100);
            };
/*
            xhr.addEventListener('progress', (event: ProgressEvent) => {
                log.info('Progress', event);
                const percentage = (event.loaded / event.total) * 100;
                log.info(percentage); // Update progress here
            })
*/

            xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4) {
                    return;
                }
                if (xhr.status !== 200) {
                    reject();
                }
                resolve(xhr.response);
            };
            xhr.open('POST', `${backendBaseURL}upload/up5?json=1`, true);
            xhr.send(uploadData);
            //TODO must be cleaned up?
        });

        uploadPromise.then((d: any) => {
            log.debug('uploadSuccess: ', d);
            storeFile(`${backendBaseURL}storeUserFile`, d.f_id, question.chat_id).then((r) => {
                r.json().then((responseObj: any) => {
                    log.trace(responseObj);
                    if (responseObj.s === 1) {
                        answerCallback(makePollAnswerMsg({
                            // eslint-disable-next-line @typescript-eslint/camelcase
                            o_ans:responseObj.response.fileName,
                            ansID: 1
                        }, question));
                    } else {
                        setIsUploading(false);
                        log.error("store uploaded file failed at application level");
                    }
                })
            }, () => {
                setIsUploading(false);
                log.error("store uploaded file failed at network level");
            });
        }, (d: boolean) => {
            //TODO handle server response for failure
            setIsUploading(false);
            log.error("upload failed", d);
        });
    }

    // TODO is it better to lift createObjectURL up and avoid creating a new temp URL on every render,
    //  or can we just not mind?
    const previewContent = <div className="previewWrapper">
                            <ul>
                                {Object.keys(selectedFiles).map( (fName: string) => (
                                  // eslint-disable-next-line react/jsx-key
                                    <li className="previewSingle">
                                        {isImageMimeType(selectedFiles[fName].type) && (
                                            <img class={"imgPreview"} src={URL.createObjectURL(selectedFiles[fName])} />
                                        )}
                                        <figcaption>
                                            {selectedFiles[fName].name}
                                            {(isUploading && uploadPercent) && <progress max="100" value={uploadPercent} />}
                                        </figcaption>
                                        <a className="butt delete"
                                           onClick={() => { removeSelectedFile(fName); }}>
                                            <IcoCloudUpload />
                                        </a>
                                    </li>)
                                )}
                            </ul>
    </div>;

    return <div className="uploader">
    {previewContent}
    <form name="inputForm"
                 role="form"
                 className="{invalidSubmitted: showErr()}">
        <div class="openAns">
            <input
                   id="chatInput"
                   onChange={handleChange}
                   ref={fileInputField}
                   type="file"
                   title=""
                   value=""
                   autoComplete='off'
                   required={true} />
            <button onClick={handleSubmit}>
                <svg viewBox="0 0 640 512"><path d="M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-139.9 63.7l-10.8 10.8c-9.6 9.6-25.2 9.3-34.5-.5L320 266.1V392c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V266.1l-32.4 34.5c-9.3 9.9-24.9 10.1-34.5.5l-10.8-10.8c-9.4-9.4-9.4-24.6 0-33.9l92.7-92.7c9.4-9.4 24.6-9.4 33.9 0l92.7 92.7c9.4 9.4 9.4 24.6.1 33.9z" /></svg>
                <span>upload</span>
            </button>
        </div>
    </form>
    </div>
}
